/**
 * Milestone 1 streaming UX master experiment eligibility check.
 *
 * `platform_editor_ai_streaming_ux_experience_m1` is the cohort control for the M1
 * streaming UX. It directly controls quick actions block streaming, streaming grey-out
 * suppression and quick actions agent attribution. Other M1 slices may apply additional
 * eligibility checks while remaining within the same cohort.
 *
 * One treatment is NOT gated on `isEnabled` here:
 *
 * - The AIFC prompt/modal presentation (narrower modal inset, AIFC placeholder, inline
 *   agent selector) has its own `platform_editor_ai_prompt_updates` experiment, which
 *   the M1 cohort can also opt into through this experiment's `enablePromptUpdates`
 *   parameter (see `prompt-updates-enabled.ts`).
 *
 * Every remaining consumer is action-driven, so only the exposure-logging variant is
 * exported. Evaluate it after any prerequisite checks, so only users who can receive the
 * treatment are enrolled. It defaults to `false`, leaving M1 off for an absent or
 * uninitialised experiment value rather than exposing the UX unexpectedly. A future render
 * path slice needs a no-exposure variant added back alongside a canonical exposure point.
 */
import { isExperimentEnabled } from '@atlaskit/platform-feature-experiments/is-experiment-enabled';

/**
 * Switcheroo key for the Milestone 1 streaming UX master experiment.
 *
 * Exported so tests and callers reference a single source of truth for the experiment name.
 */
export const STREAMING_UX_EXPERIENCE_M1 = 'platform_editor_ai_streaming_ux_experience_m1';

/**
 * Exposure-logging eligibility check. Evaluate after prerequisite checks - see file-level JSDoc.
 */
export const isStreamingUxExperienceM1Enabled = (): boolean =>
	isExperimentEnabled(STREAMING_UX_EXPERIENCE_M1);
